import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Popconfirm, message, Form, Row, Col } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { API_URL } from "../../config";
import AntDesignTable from "../common/antTable/AntDesignTable";
import DeviceForm from "./DeviceForm";

const DevicesContainer = () => {
  const [devices, setDevices] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentDevice, setCurrentDevice] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = async () => {
    try {
      const response = await axios.get(`${API_URL}/device/`);
      setDevices(response.data);
    } catch (error) {
      console.error("There was an error fetching the device data!", error);
    }
  };

  const fetchDeviceDetails = async (id) => {
    try {
      const response = await axios.get(`${API_URL}/device/?device_id=${id}`);
      setCurrentDevice(response.data);
      form.setFieldsValue(response.data);
    } catch (error) {
      console.error("There was an error fetching the device details!", error);
    }
  };

  const handleEdit = async (record) => {
    await fetchDeviceDetails(record.id);
    setIsModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/device/${id}`);
      message.success("Device deleted successfully");
      fetchDevices();
    } catch (error) {
      console.error("There was an error deleting the device data!", error);
      message.error("Failed to delete the device");
    }
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      await axios.patch(
        `${API_URL}/device/${currentDevice.id}`,
        form.getFieldsValue(),
      );
      message.success("Device updated successfully");
      setIsModalVisible(false);
      fetchDevices();
    } catch (error) {
      console.error("There was an error updating the device data!", error);
      message.error("Failed to update the device");
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Units",
      dataIndex: "units",
      key: "units",
    },
    {
      title: "Device Group",
      dataIndex: "device_group",
      key: "device_group",
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <span>
          <Row gutter={[8, 8]}>
            <Col xs={12} sm={8} md={6}>
              <Button
                className="edit-button"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Col>
          </Row>
          {/* <Popconfirm
            title="Are you sure you want to delete this device?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              className="delete-button"
              icon={<DeleteOutlined />}
              style={{ marginLeft: 8 }}
            />
          </Popconfirm> */}
        </span>
      ),
    },
  ];

  return (
    <React.Fragment>
      <AntDesignTable columns={columns} tableData={devices} />
      <DeviceForm
        visible={isModalVisible}
        onCancel={handleCancel}
        onConfirm={handleOk}
        form={form}
        initialValues={currentDevice}
      />
    </React.Fragment>
  );
};

export default DevicesContainer;
